import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { command: String }
  static targets = ["copyIcon", "checkIcon"]

  copy() {
    navigator.clipboard.writeText(this.commandValue).then(() => {
      this.copyIconTarget.classList.add("hidden")
      this.checkIconTarget.classList.remove("hidden")

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.checkIconTarget.classList.add("hidden")
        this.copyIconTarget.classList.remove("hidden")
      }, 2000)
    })
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
